import {Injectable} from '@angular/core';
import {Scan3dGroupModel} from '../../../api/entity/scan3dGroup.model';
import {Scan3dGroupConverter} from '../../../api/entity/converter/scan3dGroup.converter';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {Scan3dGroupDataService} from './scan3dGroupData.service';

@Injectable()
export class Scan3dGroupDataServiceAdapter extends AbstractDataServiceDtoAdapter<Scan3dGroupModel, Scan3dGroupConverter> {
    constructor(dataService: Scan3dGroupDataService, converter: Scan3dGroupConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): Scan3dGroupModel {
        return new Scan3dGroupModel();
    }
}
